import _ from 'lodash';

import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import React from 'react';
import { Flex, Box } from 'reflexbox';
import {
  Checkbox,
  Heading,
  Label,
  Select,
  Text,
  Tooltip,
} from 'rebass';

import config from 'frontend/config';
import SvgIcons from 'frontend/SvgIcons';

import {
  simcVersions as origSimcVersions,
  iterationOptions,
  fightStyles,
  fightLengths,
  enemyCounts,
  getFoods,
  getFlasks,
  getPotions,
  getAugments,

  expansionOptions,
} from 'shared/simcOptions';
import SimcInput from 'shared/simcinput';
import SharedConfig from 'shared/config';

import { dwarn, isBetaSite } from 'frontend/util';
import actions from 'frontend/state/actions';
import { selectors, expansionOptionConfig } from 'frontend/state/reducers/simbot/simcOptions';
import { selectors as userSelectors } from 'frontend/state/reducers/user';
import { selectors as simbotSelectors } from 'frontend/state/reducers/simbot';

import {
  DarkerBox,
  If,
  InfoTooltip,
  SmallButton,
  ReactSelect,
  ToggleView,
  WowIcon,
} from 'frontend/components';

const ExpansionOptionDropdown = ({ name, value, expansionOption, override, inCustomApl, onChange }) => {
  const usedValue = override !== null ? override : value;

  const valueOption = _.find(expansionOption.values, { value: usedValue });
  const valueName = valueOption.name || valueOption.value;

  let message = valueOption.description;

  let disabled = false;

  if (override !== null) {
    disabled = true;
    message = `Fight Style overrides to ${valueName}`;
  } else if (inCustomApl) {
    disabled = true;
    message = 'Remove from Custom APL to choose a value here';
  }

  const label = (
    <Flex align="center" mb={0}>
      <If
        condition={expansionOption.icon}
        then={() => (
          <Box mr={1} style={{ height: 14, lineHeight: 1 }}>
            <WowIcon
              id={expansionOption.itemId}
              type="item"
              icon={expansionOption.icon}
              size={14}
            />
          </Box>
        )}
      />
      <Tooltip
        title={(
          <Text size={12} style={{ fontWeight: 500, minWidth: 200, maxWidth: 250, whiteSpace: 'normal' }}>
            {expansionOption.description}
          </Text>
        )}
      >
        <Label>
          {expansionOption.name}
        </Label>
      </Tooltip>
    </Flex>
  );

  return (
    <Box>
      {label}
      <Select
        id={`AdvancedSimOptions-ExpansionOption-${name}`}
        name={name}
        value={value}
        label=""
        message={message}
        onChange={e => onChange(e.target.value)}
        options={_.map(expansionOption.values, option => {
          const display = option.name || option.value;
          return {
            value: option.value,
            children: display,
          };
        })}
        backgroundColor={config.colors.primary}
        color={disabled ? config.colors.gray : undefined}
        disabled={disabled}
      />
    </Box>
  );
};

ExpansionOptionDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  expansionOption: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,

  override: PropTypes.number,
  inCustomApl: PropTypes.bool,
};
ExpansionOptionDropdown.defaultProps = {
  override: null,
  inCustomApl: false,
};


const ExpansionOptionCheckbox = ({ name, value, expansionOption, override, inCustomApl, onChange }) => {
  const disabled = override !== null || inCustomApl;
  const label = (
    <Flex align="center">
      <If
        condition={expansionOption.icon}
        then={() => (
          <Box mr={1} style={{ height: 14 }}>
            <WowIcon
              icon={expansionOption.icon}
              size={14}
            />
          </Box>
        )}
      />
      <Tooltip
        title={(
          <>
            <Text size={12} style={{ fontWeight: 500, minWidth: 200, maxWidth: 250, whiteSpace: 'normal' }}>
              {expansionOption.description}
            </Text>
            <If
              condition={inCustomApl}
              then={() => (
                <Text size={12} mt={1} style={{ fontWeight: 500, minWidth: 200, maxWidth: 250, whiteSpace: 'normal' }}>
                  Disabled because already defined in Custom APL section.
                </Text>
              )}
            />
          </>
        )}
      >
        <Text size={14} style={{ opacity: 0.625 }}>
          {expansionOption.name}
        </Text>
      </Tooltip>
    </Flex>
  );
  return (
    <Flex pl={1} mt={2} align="center">
      <Checkbox
        mb={0}
        pb={0}
        id={`AdvancedSimOptions-ExpansionOption-${name}`}
        name={name}
        label={label}
        checked={value}
        onChange={e => onChange(!!e.target.value)}
        backgroundColor={
          override !== null
            ? config.colors.midgray
            : config.colors.black
        }
        disabled={disabled}
        style={{ textDecoration: disabled ? 'line-through' : null, opacity: 1 }}
      />
    </Flex>
  );
};

ExpansionOptionCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  expansionOption: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,

  override: PropTypes.bool,
  inCustomApl: PropTypes.bool,
};
ExpansionOptionCheckbox.defaultProps = {
  override: null,
  inCustomApl: false,
};

const ExpansionOption = ({ name, value, fightStyle, aplData, onChange }) => {
  const option = _.find(expansionOptions, { key: name });

  const fightStyleInfo = _.find(fightStyles, { value: fightStyle });
  const overrides = _.get(fightStyleInfo, 'overrides', {});
  const inCustomApl = Boolean(SimcInput.find(aplData, option.simcOption));

  switch (option.type) {
    case 'int': {
      return (
        <ExpansionOptionDropdown
          name={name}
          value={value}
          expansionOption={option}
          override={overrides[name]}
          inCustomApl={inCustomApl}
          onChange={i => onChange(parseInt(i, 10))}
        />
      );
    }
    case 'string': {
      return (
        <ExpansionOptionDropdown
          name={name}
          value={value}
          expansionOption={option}
          override={overrides[name]}
          inCustomApl={inCustomApl}
          onChange={onChange}
        />
      );
    }
    case 'bool': {
      return (
        <ExpansionOptionCheckbox
          name={name}
          value={value}
          expansionOption={option}
          override={overrides[name]}
          inCustomApl={inCustomApl}
          onChange={onChange}
        />
      );
    }
    default:
      dwarn(`Unhandled expansion option: Key ${option.key}, type ${option.type}`);
      return null;
  }
};

ExpansionOption.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  fightStyle: PropTypes.string.isRequired,
  aplData: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

// eslint-disable-next-line no-unused-vars
const makeExpansionAction = (name) => {
  const optionConfig = _.find(expansionOptionConfig, { key: name });

  const mapStateToProps = state => ({
    name,
    value: selectors[name](state),
    fightStyle: selectors.fightStyle(state),
    aplData: simbotSelectors.aplData(state),
  });
  const mapDispatchToProps = {
    onChange: actions[optionConfig.actionFunc],
  };

  return connect(mapStateToProps, mapDispatchToProps)(ExpansionOption);
};

// just make an option for everything and refernce them later
// eslint-disable-next-line no-unused-vars
const xOptions = _.fromPairs(_.map(expansionOptions, opt => {
  return [
    opt.key,
    makeExpansionAction(opt.key),
  ];
}));

const AdvancedSimOptions = ({
  open,
  simcVersion,
  iterations,
  fightStyle,
  fightLength,
  enemyCount,
  smartAggressive,

  food,
  potion,
  flask,
  augmentation,

  bloodlust,
  arcaneIntellect,
  fortitude,
  battleShout,
  mysticTouch,
  chaosBrand,
  bleeding,
  skyfury,
  markOfTheWild,
  powerInfusion,
  huntersMark,

  reportDetails,

  ptr,
  showAllOptions,
  hideExtendedOptions,

  canPtr,

  apl,

  toggleAdvancedOptions,
  onChangeSimcVersion,
  // onChangeIterations,
  onChangeFightStyle,
  onChangeFightLength,
  onChangeEnemyCount,
  onChangeSmartAggressive,

  onOptimalRaidClick,
  onTargetDummyClick,

  onChangeFood,
  onChangePotion,
  onChangeFlask,
  onChangeAugmentation,

  onToggleBloodlust,
  onToggleArcaneIntellect,
  onToggleFortitude,
  onToggleBattleShout,
  onToggleMysticTouch,
  onToggleChaosBrand,
  onToggleBleeding,
  onToggleSkyfury,
  onToggleMarkOfTheWild,
  onTogglePowerInfusion,
  onToggleHuntersMark,

  onToggleReportDetails,
  onTogglePtr,

  onToggleShowAllOptions,
  reset,
}) => {
  let details;
  const simcVersions = origSimcVersions;

  const fightStyleInfo = _.find(fightStyles, { value: fightStyle });
  const fightStyleOverrides = _.get(fightStyleInfo, 'overrides', {});

  if (!open) {
    const iterationsOption = _.find(iterationOptions, { value: iterations });
    const iterationsName = iterationsOption.name || `${iterationsOption.value.toLocaleString()} iterations`;
    const fightStyleName = _.find(fightStyles, { value: fightStyle }).name;
    const fightLengthName = _.find(fightLengths, { value: fightLength }).name;
    const simcVersionName = _.find(simcVersions, { value: simcVersion }).name;
    const enemyCountName = _.find(enemyCounts, { value: enemyCount }).name;
    details = (
      <span style={{ opacity: 0.7, fontSize: '16px' }}>
        {iterationsName}, {fightStyleName},{' '}
        {enemyCountName}, {fightLengthName}, SimC {simcVersionName}
      </span>
    );
  }

  let simcVersionMessage;
  let simcVersionToUse = simcVersion;
  if (isBetaSite() && SharedConfig.beta.simcVersion) {
    simcVersionToUse = SharedConfig.beta.simcVersion;
    simcVersionMessage = 'Beta site always uses this version';
  } else {
    simcVersionMessage = _.get(_.find(simcVersions, { value: simcVersionToUse }), 'description');
  }

  let aplData;
  if (apl) {
    aplData = SimcInput.parse(apl);
  }

  const consumables = [{
    key: 'potion',
    value: potion,
    collection: getPotions(),
    onChange: onChangePotion,
  }, {
    key: 'food',
    value: food,
    collection: getFoods(),
    onChange: onChangeFood,
  }, {
    key: 'flask',
    value: flask,
    collection: getFlasks(),
    onChange: onChangeFlask,
  }, {
    key: 'augmentation',
    value: augmentation,
    collection: getAugments(),
    onChange: onChangeAugmentation,
  }];

  const icon = (
    <SvgIcons.options.small
      style={{
        fill: config.colors.iconInfo,
        width: 26,
        height: 26,
      }}
    />
  );
  const titleEl = (
    <Flex align="center">
      <Box mr={1}>
        {icon}
      </Box>
      <Box>
        Simulation Options: {details}
      </Box>
    </Flex>
  );
  return (
    <Box>
      <ToggleView
        label={titleEl}
        open={open}
        onClick={toggleAdvancedOptions}
      >
        <DarkerBox ml={2} pl={2}>
          <Flex wrap gutter={1} col={12} mt={1}>
            <Box sm={12} md={3} px={1} auto>
              <Select
                id="AdvancedSimOptions-fightStyle"
                label="Fight Style"
                name="fightStyle"
                value={fightStyle}
                message={_.get(_.find(fightStyles, { value: fightStyle }), 'description')}
                onChange={e => onChangeFightStyle(e.target.value)}
                options={_.map(_.filter(fightStyles, { public: true }), style => {
                  const display = style.name || style.value;
                  return {
                    value: style.value,
                    children: display,
                  };
                })}
                backgroundColor={config.colors.primary}
              />
            </Box>
            <Box sm={12} md={3} px={1}>
              <Select
                id="AdvancedSimOptions-numEnemies"
                label="Number of Bosses"
                name="numEnemies"
                value={enemyCount}
                message={_.has(fightStyleOverrides, 'enemyCount')
                  ? `Fight Style overrides to ${_.get(
                    _.find(enemyCounts, { value: fightStyleOverrides.enemyCount }),
                    'name',
                    fightStyleOverrides.enemyCount,
                  )}`
                  : _.get(_.find(enemyCounts, { value: enemyCount }), 'description')}
                onChange={e => onChangeEnemyCount(parseInt(e.target.value, 10))}
                options={enemyCounts.map(enemy => ({
                  value: enemy.value,
                  children: enemy.name || enemy.value,
                }))}
                backgroundColor={config.colors.primary}
                color={_.has(fightStyleOverrides, 'enemyCount') ? config.colors.gray : undefined}
                disabled={_.has(fightStyleOverrides, 'enemyCount')}
              />
            </Box>
            <Box sm={12} md={3} px={1} auto>
              <Select
                id="AdvancedSimOptions-fightLength"
                label="Fight Length"
                name="fightLength"
                value={fightLength}
                message={_.has(fightStyleOverrides, 'fightLength')
                  ? `Fight Style overrides to ${_.get(
                    _.find(fightLengths, { value: fightStyleOverrides.fightLength }),
                    'name',
                    fightStyleOverrides.fightLength,
                  )}`
                  : _.find(fightLengths, { value: fightLength })?.description}
                onChange={e => onChangeFightLength(parseInt(e.target.value, 10))}
                options={_.map(fightLengths, length => {
                  const display = length.name || length.value;
                  return {
                    value: length.value,
                    children: display,
                  };
                })}
                backgroundColor={config.colors.primary}
                color={_.has(fightStyleOverrides, 'fightLength') ? config.colors.gray : undefined}
                disabled={_.has(fightStyleOverrides, 'fightLength')}
              />
            </Box>
            <Box sm={12} md={3} px={1}>
              <Select
                id="AdvancedSimOptions-simcVersion"
                label="SimC Version"
                name="simcVersion"
                value={simcVersionToUse}
                message={simcVersionMessage}
                onChange={e => onChangeSimcVersion(e.target.value)}
                options={_.map(_.filter(simcVersions, v => v.public), version => ({
                  value: version.value,
                  children: version.name || version.value,
                }))}
                disabled={isBetaSite()}
                backgroundColor={config.colors.primary}
              />
            </Box>
            <If
              condition={isBetaSite()}
              then={() => (
                <Box sm={12} md={3} px={1} mb={2}>
                  <Checkbox
                    id="AdvancedSimOptions-multistageAggressive"
                    label="Aggressive Smart Sim (Experimental)"
                    name="multistageAggressive"
                    checked={smartAggressive}
                    onChange={onChangeSmartAggressive}
                    backgroundColor={config.colors.black}
                  />
                </Box>
              )}
            />

          </Flex>

          <If
            condition={!hideExtendedOptions}
            then={() => (
              <>
                <Heading level={5}>Embellishments</Heading>

                <Flex mb={0} mt={1} wrap>
                  <Box md={3} sm={12}>
                    <Box px={1}>
                      <Flex>
                        <xOptions.dawnDuskThreadLining />
                      </Flex>
                    </Box>
                  </Box>
                </Flex>

                {/*
                <Heading level={5}>Trinkets</Heading>

                <Flex mb={0} mt={1} wrap>
                </Flex>

                <Heading level={5}>Consumables</Heading>

                <Flex mb={0} mt={1} wrap>
                </Flex>
                */}

                {/*

                <Heading level={5}>Dungeon Trinkets</Heading>

                <Flex mb={0} mt={1} wrap>
                </Flex>

                */}

                <Text size={14} ml={1}>
                  You can use nearly any
                  {' '}
                  <a
                    // eslint-disable-next-line max-len
                    href="https://github.com/simulationcraft/simc/wiki/ExpansionOptions"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    SimC expansion-specific options
                  </a>
                  {' '}
                  in the Custom APL and SimC Options
                </Text>

              </>
            )}
          />

          {/*
          <Box sm={12} md={3} auto mt={2}>
            <Select
              id="AdvancedSimOptions-iterations"
              label="Iterations per Actor"
              name="iterations"
              value={iterations}
              message={_.get(_.find(iterationOptions, { value: iterations }), 'description')}
              onChange={e => onChangeIterations(parseInt(e.target.value, 10) || e.target.value)}
              options={_.map(_.filter(iterationOptions, { public: true }), option => {
                const display = option.name || option.value.toLocaleString();
                return {
                  value: option.value,
                  children: display,
                };
              })}
              backgroundColor={config.colors.primary}
            />
          </Box>
          */}


          <If
            condition={!hideExtendedOptions}
            then={() => (
              <If
                condition={!showAllOptions}
                then={() => (
                  <Box sm={12} md={3} my={1} key="showAllOptions">
                    <SmallButton
                      id="AdvancedSimOptions-showAllOptions"
                      onClick={onToggleShowAllOptions}
                    >
                      Show More Options
                    </SmallButton>
                  </Box>
                )}
              />
            )}
            else={() => (
              <Box sm={12} md={4} pr={1}>
                <Text my={2} ml={0} bold>
                  Additional options are not available in Advanced
                </Text>
              </Box>
            )}
          />

          <If
            condition={showAllOptions && !hideExtendedOptions}
            then={() => (
              <Box mt={2}>
                <Heading level={4} mb={1}>
                  Raid Buff Presets
                </Heading>
                <Box mb={1}>
                  <SmallButton
                    id="AdvancedSimOptions-optimalRaidBuffs"
                    p={1}
                    ml={0}
                    onClick={onOptimalRaidClick}
                  >
                    Optimal Raid Buffs
                  </SmallButton>
                  <SmallButton
                    id="AdvancedSimOptions-noBuffs"
                    p={1}
                    ml={2}
                    onClick={onTargetDummyClick}
                  >
                    No Buffs
                  </SmallButton>
                </Box>

                <Heading level={5} mt={2}>Consumables</Heading>
                <Text small mb={1}>
                  &quot;SimC Default&quot; uses the default consumables defined in the class APL/module.
                  To verify, you can run a Quick Sim and check buffs to see what was used.
                </Text>

                <Flex wrap gutter={1} col={12}>
                  {_.map(consumables, option => {
                    let disabled;

                    const options = _.map(option.collection, opt => ({
                      value: opt.value,
                      label: (
                        <Flex align="center">
                          <If
                            condition={opt.itemId}
                            then={() => (
                              <Box mr={1}>
                                <WowIcon
                                  type="item"
                                  id={opt.itemId}
                                  size={22}
                                  craftingQuality={opt.craftingQuality}
                                  noLink
                                />
                              </Box>
                            )}
                          />
                          <Text size={14}>
                            {opt.name || opt.value}
                          </Text>
                        </Flex>
                      ),
                      data: opt,
                      isDisabled: opt.disabled,
                    }));

                    let consumable = _.find(options, { value: option.value });
                    let message = _.get(consumable, 'description');

                    const aplConsumable = SimcInput.find(aplData, option.key);
                    const fightStyleConsumable = _.get(fightStyleOverrides, option.key);
                    if (aplConsumable) {
                      consumable = _.find(options, { value: aplConsumable });
                      disabled = true;
                      message = 'Potion is defined in Custom APL and Simulation Options';
                    } else if (fightStyleConsumable) {
                      consumable = _.find(options, { value: fightStyleConsumable });
                      disabled = true;
                      message = `Fight Style overrides to ${consumable.name}`;
                    }
                    return (
                      <Box sm={12} md={3} px={1} key={option.key}>
                        <ReactSelect
                          key={option.key}
                          id={`AdvancedSimOptions-${option.key}`}
                          label={_.startCase(option.key)}
                          name={option.key}
                          value={consumable}
                          message={message}
                          onChange={opt => option.onChange(opt.value)}
                          options={options}
                          backgroundColor={config.colors.primary}
                          color={disabled ? config.colors.gray : undefined}
                          disabled={disabled}
                          menuWidth={400}
                        />
                        <If
                          condition={message}
                          then={() => <Text small color={config.colors.warning}>{message}</Text>}
                        />
                      </Box>
                    );
                  })}

                  <Box md={3} sm={12}>
                    <Box px={1}>
                      <Flex>
                        <xOptions.temporaryEnchant />
                      </Flex>
                    </Box>
                  </Box>
                </Flex>

                <Heading level={5}>Raid Buffs</Heading>
                <Text small>
                  If your character provides one of these buffs, it may be used even if disabled here
                </Text>

                <Flex mb={2} wrap>
                  <Box sm={12} md={3} px={1}>
                    <Flex>
                      <Box>
                        <Checkbox
                          id="AdvancedSimOptions-bloodlust"
                          mt={1}
                          name="bloodlust"
                          label="Bloodlust"
                          checked={bloodlust}
                          onChange={onToggleBloodlust}
                          backgroundColor={
                            _.has(fightStyleOverrides, 'bloodlust')
                              ? config.colors.midgray
                              : config.colors.black
                          }
                          disabled={_.has(fightStyleOverrides, 'bloodlust')}
                          style={{ textDecoration: _.has(fightStyleOverrides, 'bloodlust') ? 'line-through' : null }}
                        />
                      </Box>
                    </Flex>
                  </Box>

                  <Box sm={12} md={3} px={1}>
                    <Flex>
                      <Box>
                        <Checkbox
                          id="AdvancedSimOptions-arcaneInt"
                          mt={1}
                          name="arcaneInt"
                          label="Arcane Intellect"
                          checked={arcaneIntellect}
                          onChange={onToggleArcaneIntellect}
                          backgroundColor={
                            _.has(fightStyleOverrides, 'arcaneIntellect')
                              ? config.colors.midgray
                              : config.colors.black
                          }
                          disabled={_.has(fightStyleOverrides, 'arcaneIntellect')}
                          style={{
                            textDecoration: _.has(fightStyleOverrides, 'arcaneIntellect') ? 'line-through' : null,
                          }}
                        />
                      </Box>
                    </Flex>
                  </Box>
                  <Box sm={12} md={3} px={1}>
                    <Flex>
                      <Box>
                        <Checkbox
                          id="AdvancedSimOptions-powerWordFort"
                          mt={1}
                          name="powerWordFort"
                          label="Power Word: Fortitude"
                          checked={fortitude}
                          onChange={onToggleFortitude}
                          backgroundColor={
                            _.has(fightStyleOverrides, 'fortitude')
                              ? config.colors.midgray
                              : config.colors.black
                          }
                          disabled={_.has(fightStyleOverrides, 'fortitude')}
                          style={{
                            textDecoration: _.has(fightStyleOverrides, 'fortitude') ? 'line-through' : null,
                          }}
                        />
                      </Box>
                    </Flex>
                  </Box>
                  <Box sm={12} md={3} px={1}>
                    <Flex>
                      <Box>
                        <Checkbox
                          id="AdvancedSimOptions-markOfTheWild"
                          mt={1}
                          name="markOfTheWild"
                          label="Mark of the Wild"
                          checked={markOfTheWild}
                          onChange={onToggleMarkOfTheWild}
                          backgroundColor={
                            _.has(fightStyleOverrides, 'markOfTheWild')
                              ? config.colors.midgray
                              : config.colors.black
                          }
                          disabled={_.has(fightStyleOverrides, 'markOfTheWild')}
                          style={{
                            textDecoration: _.has(fightStyleOverrides, 'markOfTheWild') ? 'line-through' : null,
                          }}
                        />
                      </Box>
                    </Flex>
                  </Box>
                  <Box sm={12} md={3} px={1}>
                    <Flex>
                      <Box>
                        <Checkbox
                          id="AdvancedSimOptions-battleShout"
                          mt={1}
                          name="battleShout"
                          label="Battle Shout"
                          checked={battleShout}
                          onChange={onToggleBattleShout}
                          backgroundColor={
                            _.has(fightStyleOverrides, 'battleShout')
                              ? config.colors.midgray
                              : config.colors.black
                          }
                          disabled={_.has(fightStyleOverrides, 'battleShout')}
                          style={{
                            textDecoration: _.has(fightStyleOverrides, 'battleShout') ? 'line-through' : null,
                          }}
                        />
                      </Box>
                    </Flex>
                  </Box>
                  <Box sm={12} md={3} px={1}>
                    <Flex>
                      <Box>
                        <Checkbox
                          id="AdvancedSimOptions-mysticTouch"
                          mt={1}
                          name="mysticTouch"
                          label="Mystic Touch (5% Physical Damage)"
                          checked={mysticTouch}
                          onChange={onToggleMysticTouch}
                          backgroundColor={
                            _.has(fightStyleOverrides, 'mysticTouch')
                              ? config.colors.midgray
                              : config.colors.black
                          }
                          disabled={_.has(fightStyleOverrides, 'mysticTouch')}
                          style={{
                            textDecoration: _.has(fightStyleOverrides, 'mysticTouch') ? 'line-through' : null,
                          }}
                        />
                      </Box>
                    </Flex>
                  </Box>
                  <Box sm={12} md={3} px={1}>
                    <Flex>
                      <Box>
                        <Checkbox
                          id="AdvancedSimOptions-chaosBrand"
                          mt={1}
                          name="chaosBrand"
                          label="Chaos Brand (3% Magic Damage)"
                          checked={chaosBrand}
                          onChange={onToggleChaosBrand}
                          backgroundColor={
                            _.has(fightStyleOverrides, 'chaosBrand')
                              ? config.colors.midgray
                              : config.colors.black
                          }
                          disabled={_.has(fightStyleOverrides, 'chaosBrand')}
                          style={{
                            textDecoration: _.has(fightStyleOverrides, 'chaosBrand') ? 'line-through' : null,
                          }}
                        />
                      </Box>
                    </Flex>
                  </Box>
                  <Box sm={12} md={3} px={1}>
                    <Flex>
                      <Box>
                        <Checkbox
                          id="AdvancedSimOptions-skyfury"
                          mt={1}
                          name="skyfury"
                          label="Skyfury"
                          checked={skyfury}
                          onChange={onToggleSkyfury}
                          backgroundColor={
                            _.has(fightStyleOverrides, 'skyfury')
                              ? config.colors.midgray
                              : config.colors.black
                          }
                          disabled={_.has(fightStyleOverrides, 'skyfury')}
                          style={{
                            textDecoration: _.has(fightStyleOverrides, 'skyfury') ? 'line-through' : null,
                          }}
                        />
                      </Box>
                    </Flex>
                  </Box>
                  <Box sm={12} md={3} px={1}>
                    <Flex>
                      <Box>
                        <Checkbox
                          id="AdvancedSimOptions-huntersMark"
                          mt={1}
                          name="huntersMark"
                          label="Hunter's Mark"
                          checked={huntersMark}
                          onChange={onToggleHuntersMark}
                          backgroundColor={
                            _.has(fightStyleOverrides, 'huntersMark')
                              ? config.colors.midgray
                              : config.colors.black
                          }
                          disabled={_.has(fightStyleOverrides, 'huntersMark')}
                          style={{
                            textDecoration: _.has(fightStyleOverrides, 'huntersMark') ? 'line-through' : null,
                          }}
                        />
                      </Box>
                    </Flex>
                  </Box>
                  <Box sm={12} md={3} px={1}>
                    <Flex align="center">
                      <Box mr={1}>
                        <Checkbox
                          id="AdvancedSimOptions-powerInfusion"
                          mt={1}
                          name="powerInfusion"
                          label="Power Infusion (Beta)"
                          checked={powerInfusion}
                          onChange={onTogglePowerInfusion}
                          backgroundColor={
                            _.has(fightStyleOverrides, 'powerInfusion')
                              ? config.colors.midgray
                              : config.colors.black
                          }
                          disabled={_.has(fightStyleOverrides, 'powerInfusion')}
                          style={{
                            textDecoration: _.has(fightStyleOverrides, 'powerInfusion') ? 'line-through' : null,
                          }}
                        />
                      </Box>
                      <InfoTooltip>
                        May not work for all specs!
                      </InfoTooltip>
                    </Flex>
                  </Box>
                  <Box sm={12} md={3} px={1}>
                    <Flex align="center">
                      <Box mr={1}>
                        <Checkbox
                          id="AdvancedSimOptions-bleeding"
                          mt={1}
                          name="bleeding"
                          label="Bleeding"
                          checked={bleeding}
                          onChange={onToggleBleeding}
                          backgroundColor={
                            _.has(fightStyleOverrides, 'bleeding')
                              ? config.colors.midgray
                              : config.colors.black
                          }
                          disabled={_.has(fightStyleOverrides, 'bleeding')}
                          style={{
                            textDecoration: _.has(fightStyleOverrides, 'bleeding') ? 'line-through' : null,
                          }}
                        />
                      </Box>
                      <InfoTooltip>
                        Affects Bloodseeker talent for Survival Hunters
                      </InfoTooltip>
                    </Flex>
                  </Box>
                </Flex>

                <Heading level={5}>Misc Options</Heading>

                <Flex mb={2} wrap>
                  <Box sm={12} md={3} px={1}>
                    <Flex>
                      <Box>
                        <Checkbox
                          id="AdvancedSimOptions-reportDetails"
                          mt={1}
                          name="reportDetails"
                          label="Detailed SimC Report"
                          checked={reportDetails}
                          onChange={onToggleReportDetails}
                          backgroundColor={config.colors.black}
                        />
                      </Box>
                    </Flex>
                  </Box>

                  <If
                    condition={canPtr || ptr || isBetaSite}
                    then={() => (
                      <Box sm={12} md={3} px={1}>
                        <Flex align="flex-end">
                          <Box>
                            <Checkbox
                              id="AdvancedSimOptions-ptr"
                              mt={1}
                              name="ptr"
                              label="PTR Simulation"
                              checked={ptr}
                              onChange={onTogglePtr}
                              backgroundColor={config.colors.black}
                            />
                          </Box>
                          <Box mb={1} pl={1}>
                            <InfoTooltip>
                              PTR sims are likely to be buggy, incomplete, and/or inaccurate.
                              Use with caution! Caveat emptor!
                            </InfoTooltip>
                          </Box>
                        </Flex>
                      </Box>
                    )}
                  />
                </Flex>

                {/*
                <Heading level={5}>Archived Options</Heading>

                <Flex mb={0} mt={1} wrap>
                  <Box md={3} sm={12}>
                    <Box pr={1}>
                      <Flex>
                        <xOptions.unboundChangelingStatType />
                      </Flex>
                    </Box>
                  </Box>
                </Flex>
                */}

                <If
                  condition={showAllOptions}
                  then={() => (
                    <Box sm={12} md={3} mt={1} mb={2}>
                      <SmallButton
                        id="AdvancedSimOptions-showFewerOptions"
                        onClick={onToggleShowAllOptions}
                      >
                        Show Fewer Options
                      </SmallButton>
                    </Box>
                  )}
                />
              </Box>
            )}
          />
          <Flex justify="flex-end">
            {/* This is intentionally a link, not a button. Reduces chance of misclick when user means to click Show
                More Options */}
            {/* eslint-disable-next-line */}
            <a
              id="AdvancedSimOptions-restoreDefaultOptions"
              theme="secondary"
              onClick={reset}
              p={1}
              mt={2}
              style={{ cursor: 'pointer' }}
            >
              Restore Default Options
            </a>
          </Flex>
        </DarkerBox>
      </ToggleView>
    </Box>
  );
};

AdvancedSimOptions.propTypes = {
  open: PropTypes.bool.isRequired,
  simcVersion: PropTypes.string.isRequired,
  iterations: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  fightStyle: PropTypes.string.isRequired,
  fightLength: PropTypes.number.isRequired,
  enemyCount: PropTypes.number.isRequired,
  smartAggressive: PropTypes.bool,

  showAllOptions: PropTypes.bool.isRequired,
  hideExtendedOptions: PropTypes.bool,
  food: PropTypes.string,
  potion: PropTypes.string,
  flask: PropTypes.string,
  augmentation: PropTypes.string,

  bloodlust: PropTypes.bool.isRequired,
  arcaneIntellect: PropTypes.bool.isRequired,
  fortitude: PropTypes.bool.isRequired,
  battleShout: PropTypes.bool.isRequired,
  mysticTouch: PropTypes.bool.isRequired,
  chaosBrand: PropTypes.bool.isRequired,
  skyfury: PropTypes.bool.isRequired,
  markOfTheWild: PropTypes.bool.isRequired,
  powerInfusion: PropTypes.bool.isRequired,
  bleeding: PropTypes.bool.isRequired,
  huntersMark: PropTypes.bool.isRequired,

  apl: PropTypes.string,

  reportDetails: PropTypes.bool.isRequired,
  ptr: PropTypes.bool.isRequired,

  canPtr: PropTypes.bool.isRequired,

  toggleAdvancedOptions: PropTypes.func.isRequired,
  onChangeSimcVersion: PropTypes.func.isRequired,
  // onChangeIterations: PropTypes.func.isRequired,
  onChangeFightStyle: PropTypes.func.isRequired,
  onChangeFightLength: PropTypes.func.isRequired,
  onChangeEnemyCount: PropTypes.func.isRequired,
  onChangeSmartAggressive: PropTypes.func.isRequired,

  onChangeFood: PropTypes.func.isRequired,
  onChangeAugmentation: PropTypes.func.isRequired,
  onChangePotion: PropTypes.func.isRequired,
  onChangeFlask: PropTypes.func.isRequired,
  onToggleShowAllOptions: PropTypes.func.isRequired,
  onOptimalRaidClick: PropTypes.func.isRequired,
  onToggleReportDetails: PropTypes.func.isRequired,
  onTogglePtr: PropTypes.func.isRequired,

  onTargetDummyClick: PropTypes.func.isRequired,

  onToggleBloodlust: PropTypes.func.isRequired,
  onToggleArcaneIntellect: PropTypes.func.isRequired,
  onToggleFortitude: PropTypes.func.isRequired,
  onToggleBattleShout: PropTypes.func.isRequired,
  onToggleMysticTouch: PropTypes.func.isRequired,
  onToggleChaosBrand: PropTypes.func.isRequired,
  onToggleSkyfury: PropTypes.func.isRequired,
  onToggleMarkOfTheWild: PropTypes.func.isRequired,
  onTogglePowerInfusion: PropTypes.func.isRequired,
  onToggleBleeding: PropTypes.func.isRequired,
  onToggleHuntersMark: PropTypes.func.isRequired,

  reset: PropTypes.func.isRequired,
};

AdvancedSimOptions.defaultProps = {
  potion: null,
  food: null,
  flask: null,
  augmentation: null,
  hideExtendedOptions: false,
  apl: null,
  smartAggressive: false,
};

const mapStateToProps = state => ({
  open: selectors.open(state),
  simcVersion: selectors.simcVersion(state),
  iterations: selectors.iterations(state),
  fightStyle: selectors.fightStyle(state),
  fightLength: selectors.fightLength(state),
  enemyCount: selectors.enemyCount(state),
  smartAggressive: selectors.smartAggressive(state),

  food: selectors.food(state),
  potion: selectors.potion(state),
  flask: selectors.flask(state),
  augmentation: selectors.augmentation(state),
  reportDetails: selectors.reportDetails(state),
  ptr: selectors.ptr(state),

  bloodlust: selectors.bloodlust(state),
  arcaneIntellect: selectors.arcaneIntellect(state),
  fortitude: selectors.fortitude(state),
  battleShout: selectors.battleShout(state),
  mysticTouch: selectors.mysticTouch(state),
  chaosBrand: selectors.chaosBrand(state),
  bleeding: selectors.bleeding(state),
  skyfury: selectors.skyfury(state),
  markOfTheWild: selectors.markOfTheWild(state),
  powerInfusion: selectors.powerInfusion(state),
  huntersMark: selectors.huntersMark(state),

  apl: simbotSelectors.apl(state),

  showAllOptions: selectors.showAllOptions(state),

  canPtr: userSelectors.canPtr(state),
});

const mapDispatchToProps = {
  toggleAdvancedOptions: actions.toggleAdvancedOptions,
  onChangeSimcVersion: actions.selectSimcVersion,
  // onChangeIterations: actions.selectIterations,
  onChangeFightStyle: actions.selectFightStyle,
  onChangeFightLength: actions.selectFightLength,
  onChangeEnemyCount: actions.selectEnemyCount,
  onChangeSmartAggressive: actions.toggleSmartAggressive,

  onOptimalRaidClick: () => actions.setOptionsPreset('optimalRaid'),
  onTargetDummyClick: () => actions.setOptionsPreset('targetDummy'),

  onChangeFood: actions.selectFood,
  onChangePotion: actions.selectPotion,
  onChangeFlask: actions.selectFlask,
  onChangeAugmentation: actions.selectAugmentation,

  onToggleBloodlust: actions.toggleBloodlust,
  onToggleArcaneIntellect: actions.toggleArcaneIntellect,
  onToggleFortitude: actions.toggleFortitude,
  onToggleBattleShout: actions.toggleBattleShout,
  onToggleMysticTouch: actions.toggleMysticTouch,
  onToggleChaosBrand: actions.toggleChaosBrand,
  onToggleSkyfury: actions.toggleSkyfury,
  onToggleMarkOfTheWild: actions.toggleMarkOfTheWild,
  onTogglePowerInfusion: actions.togglePowerInfusion,
  onToggleBleeding: actions.toggleBleeding,
  onToggleHuntersMark: actions.toggleHuntersMark,

  onToggleReportDetails: actions.toggleReportDetails,
  onTogglePtr: actions.togglePtr,

  onToggleShowAllOptions: actions.toggleShowAllOptions,

  reset: actions.resetAdvancedOptions,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedSimOptions);
